export enum SUPPLIERS_ID {
  MENTAL_THERAPY = 0,
}

export enum SUPPLIER_CATEGORY {
  MENTAL_THERAPY = 'therapy',
}

export enum SUPPLIERS_STEPS {
  LOBBY = 0,
  FORM = 1,
  RESULTS = 2,
}

export enum SUPPLIERS_RESOURCES {
  profession = 'OCCUP',
  specialty = 'SPECL',
  treatmentMethod = 'GISHA',
  region = 'BRNCD',
  language = 'LNGCD',
  area = 'RGION',
}

export enum SUPPLIER_RESULT_FILTER {
  Init = 'INITIALIZATION',
  Therapy = 'THERAPY_FILTER',
}

export enum SUPPLIERS_LOCATION_STEPS {
  region = '1',
  city = '2',
  area = '3',
}
